module.exports = __webpack_public_path__ + "img/humidity.9c618b41.svg";